const getNews = state => state.news

export default {
    getNews
}